import { AccountApiNetworkError } from '../features/account/errors.ts';
import {
  AuthExpired,
  CloudflareChallenge,
  NetworkError,
  QuotaExceeded,
  SadPanda,
} from '../lib/errors.ts';
import type { ComicSource } from '../sources/types.ts';

export function connectErrorMessage(err: unknown, source: ComicSource): string {
  const rawMessage = err instanceof Error ? err.message : String(err);
  const msg = rawMessage.trim();
  if (err instanceof SadPanda) {
    return source.id === 'exhentai'
      ? 'ExHentai refused these cookies (Sad Panda). Confirm exhentai.org shows a gallery list in your browser — new e-hentai accounts need about a week before ExHentai access. If it does, paste ipb_member_id, ipb_pass_hash, and igneous from that same browser again.'
      : msg;
  }
  if (err instanceof CloudflareChallenge) {
    return `Cloudflare still challenged the worker for ${source.name}. Refresh cf_clearance and __cf_bm from a browser session that can open ${source.name}, then paste them again.`;
  }
  if (err instanceof AuthExpired) {
    return `Cookies did not validate for ${source.name}. Sign in to the source again, then re-copy the cookies.`;
  }
  if (err instanceof QuotaExceeded) {
    return `${source.name} temporarily blocked the worker IP for too many requests. Wait for the upstream ban or quota window to expire, then try again.`;
  }
  if (
    err instanceof NetworkError &&
    source.id === 'exhentai' &&
    /failed to fetch|invalid header value/i.test(msg)
  ) {
    return 'Could not send the ExHentai cookies to the proxy. If you pasted a full request-header block, paste only the Cookie line or the specific cookies: ipb_member_id, ipb_pass_hash, igneous, cf_clearance, __cf_bm, and sk.';
  }
  if (err instanceof AccountApiNetworkError) {
    return `Could not reach Bunko account sync at ${err.proxyBase}. Check the Worker proxy URL in Settings, then try again.`;
  }
  if (/^failed to fetch$/i.test(msg)) {
    return 'Could not reach Bunko account sync or the proxy. Check the worker URL in Settings and try again.';
  }
  return (
    msg ||
    `Could not save cookies for ${source.name}. Try again, or refresh the source cookies and paste them again.`
  );
}
